import Util from '../../util.js';

class Modal extends HTMLElement {

    static get observedAttributes() {
        return ['open'];
    }

    #template = document.createElement('template');
    #templateMarkup = `
    <dialog>
        <button type="button">
            <i class="material-symbols-rounded">close</i>
        </button>
        <slot name="header"></slot>
        <slot name="body"></slot>
        <slot name="footer"></slot>
    </dialog>
    `;

    constructor() {
        super();
        this.attachShadow({mode: 'open'});
        this.addStyle = Util.addStyle;
        this.addStyle('/src/styles/neptune.css');
        this.addStyle('/src/components/container/modal/modal.css');
        this.#template.innerHTML = this.#templateMarkup;
        this.shadowRoot.appendChild(this.#template.content.cloneNode(true));
        this.failed = false;
        this.dialog = null;
        this.closeButton = null;
    }

    connectedCallback() {
        if (this.failed) return;
        this.dialog = this.shadowRoot.querySelector('dialog');
        this.closeButton = this.shadowRoot.querySelector('button');
        this.setupEventListeners();
        this.setModal();
    }

    disconnectedCallback() {
        this.removeEventListeners();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (this.failed) return;
        if (!this.isConnected) return;
        if (oldValue === newValue) return;
        this.setModal();
    }

    setupEventListeners() {
        this.dialog.addEventListener('click', this.handleBackdropClick.bind(this));
        this.dialog.addEventListener('cancel', this.handleCancel.bind(this));

        if (this.closeButton) {
            this.closeButton.addEventListener('click', this.handleCloseClick.bind(this));
        }
    }

    removeEventListeners() {
        if (this.dialog) {
            this.dialog.removeEventListener('click', this.handleBackdropClick.bind(this));
            this.dialog.removeEventListener('cancel', this.handleCancel.bind(this));
        }
        if (this.closeButton) {
            this.closeButton.removeEventListener('click', this.handleCloseClick.bind(this));
        }
    }

    handleBackdropClick(event) {
        if (event.target === this.dialog) {
            this.close();
        }
    }

    handleCancel() {
        this.close();
    }

    handleCloseClick() {
        this.close();
    }

    setModal() {
        if (this.failed) return;
        if (!this.dialog) return;

        const rawOpen = (this.getAttribute('open') || '').trim().toLowerCase();
        const shouldOpen = rawOpen === 'true';

        if (shouldOpen) {
            if (!this.dialog.open) {
                this.dialog.showModal();
            }
            if (this.getAttribute('open') !== 'true') {
                this.setAttribute('open', 'true');
            }
        } else {
            if (this.dialog.open) {
                this.dialog.close();
            }
            if (this.hasAttribute('open')) {
                this.removeAttribute('open');
            }
        }
    }

    open() {
        if (!this.dialog) {
            setTimeout(() => this.open(), 0);
            return;
        }
        if (!this.hasAttribute('open')) {
            this.setAttribute('open', 'true');
        }
        this.dispatchEvent(new CustomEvent('neptune-modal-open', {
            bubbles: true,
            composed: true
        }));
    }

    close() {
        if (!this.dialog) {
            if (this.hasAttribute('open')) {
                this.removeAttribute('open');
            }
            return;
        }
        if (this.hasAttribute('open')) {
            this.removeAttribute('open');
        }
        this.dispatchEvent(new CustomEvent('neptune-modal-close', {
            bubbles: true,
            composed: true
        }));
    }
}

customElements.define('neptune-modal', Modal);
export default Modal;